module.exports = __webpack_public_path__ + "img/gustavo-lima-celular.02ae2f4e.png";